import { AnalyticsBrowser } from '@segment/analytics-next';

import config from '../config';

/**
 * Initialise Segment via the bundled `@segment/analytics-next` library rather than the
 * CDN snippet. Bundling the library into our own app JS means there is no separate
 * `analytics.min.js` request for ad-blockers to match on by path — the only network
 * calls left are the settings fetch and event POSTs, both of which route through our
 * first-party proxy when `proxyHost` is configured.
 *
 * The resulting instance is assigned to `window.analytics` so existing call sites
 * (Account.ts, the eventTrackers, and the PostHog bridge in App.ts) keep working
 * unchanged.
 */
export function initSegment(): void {
  const { token, proxyHost } = config.thirdParty.segment;

  if (!token) {
    return;
  }

  const analytics = AnalyticsBrowser.load(
    {
      writeKey: token,
      // Settings + any device-mode bundles load from <host>/cdn (Envoy strips /cdn).
      ...(proxyHost ? { cdnURL: `https://${proxyHost}/cdn` } : {}),
    },
    proxyHost
      ? {
        // Events POST to <host>/api (Envoy rewrites /api -> /v1). apiHost is host+path, no scheme.
        integrations: { 'Segment.io': { apiHost: `${proxyHost}/api` } },
      }
      : undefined,
  );

  window.analytics = analytics;

  // Initial pageview (the old snippet called analytics.page() right after load).
  analytics.page();
}
